import type { FolderStore } from './FolderStore'

export const folderStores = new Map<string, WeakRef<FolderStore>>()
